export default {
  esc: 27,
  space: 32,
  enter: 13,
};
